'use client'

import {
	RelatedCard,
	RelatedCardProps,
	SlideshowNative,
} from '@local/ui/components'
import {cx} from '@local/utils/cx'

export interface RelatedCardGridSlideshowProps {
	cards: Array<RelatedCardProps>;
	locationLabel: string;
}

export const RelatedCardGridSlideshow = ({
	cards,
	locationLabel,
}: RelatedCardGridSlideshowProps) => (
	<SlideshowNative
		containerClassName='overflow-clip'
		className={cx(
			cards.length < 5 && 'lg:justify-center',
			cards.length === 4 && 'lg-max:flex-wrap',
			'margin-px-1 gutter-gap-1 scroll-px-[var(--margin)]',
		)}
		withDotNavigation
		dotNavigationClassName={cx(
			!(cards.length === 3 || cards.length > 4) && 'hidden',
			'mt-50 margin-px-1 bottom-50 margin-left-1 gap-14 w-full',
			'[&>button]:max-w-[2.125rem] [&>button]:w-full',
			'lg:hidden',
		)}
		withPrevNextNavigation
		prevNextNavigationClassName={cx(
			cards.length < 5 && '!hidden',
			'lg-max:hidden',
			'absolute top-80 margin-right-1 flex items-center justify-center z-1',
		)}
		prevNextButtonVariant='icon'
		prevNextButtonClassName='bg-transparent disabled:border-grey-1 rounded-md p-0 w-38 h-38'
		disableObserverOnMobile
		threshold={0.8}>
		{cards.map((card, index) => (
			<RelatedCard
				{...card}
				key={index}
				index={index}
				locationLabel={locationLabel}
				isHighlight={index === 0 && cards.length === 1}
				smallMobile={cards.length === 2 || cards.length === 4} />
		))}
	</SlideshowNative>
)
